import { render } from "./videochat.vue?vue&type=template&id=1caf3d56"
import script from "./videochat.vue?vue&type=script&lang=js"
export * from "./videochat.vue?vue&type=script&lang=js"

import "./videochat.vue?vue&type=style&index=0&id=1caf3d56&lang=css"

import exportComponent from "E:\\DeepakKumarJha\\TfsProjects\\EngeeGit\\EngeeAPI\\AdminPanel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__